import { ExportFormHook } from '@app/modules/social-export/hooks/useSocialExportFactory';
import { socialExport } from '@mi-front/api-clients';
import { YoutubePublishForm } from './YoutubePublishForm';
import { YoutubeSettingsForm } from './YoutubeSettingsForm';

export const useYoutubeExport: ExportFormHook<
  socialExport.YoutubePublishDto,
  socialExport.YoutubeSettingsDto
> = () => {
  return {
    SettingsForm: YoutubeSettingsForm,
    PublishForm: YoutubePublishForm,
  };
};
